module.exports = __webpack_public_path__ + "img/55.7cd10808.jpg";